import ProgressBar from 'progressbar.js';

export default {
  init() {
    // JavaScript to be fired on all pages

    // Contact popup
    $('.contact-popup .toggle-icon.close-icon').click(function() {
      $(this).closest('.contact-popup').addClass('dismiss');
      const cookieExpiry = new Date();
      cookieExpiry.setTime(cookieExpiry.getTime() + 1 * 3600 * 1000);
      document.cookie = 'hide_contact=true; expires=' + cookieExpiry.toUTCString() + '; path=/';
    });

    // Sidebar
    $(window).on('load resize', function() {
      const banner = $('header.banner');
      const header = $('.location-header, .home-header, .header-container');
      if (header.length) {
        $('.sidebar .sidebar-fixed-height').height(header.outerHeight());
      }
      if (banner.length) {
        $('.sidebar .sidebar-container .menu-icon').height(banner.outerHeight());
      }
      $('.sidebar .sidebar-container').addClass('active');
    });

    $(window).on('load scroll', function () {
      const top = $(window).scrollTop();
      const header = $('header.banner');
      if (top > 100) {
        header.addClass('bg-white shadow-sm reduced')
      } else if (top < 80) {
        header.removeClass('bg-white shadow-sm reduced')
      } 
    });

    // $(window).on('load scroll', function () {
    //   const sidebar = $('.sidebar .sidebar-container');

    //   const viewTop = $(window).scrollTop();

    //   const animationStart = 100;
    //   const animationBuffer = 20;

    //   if (viewTop > animationStart) {
    //     sidebar.addClass('horizontal');
    //   } else if (viewTop < animationStart - animationBuffer) {
    //     sidebar.removeClass('horizontal');
    //   }
    // });

    // Magnific Popup
    $('.popup-youtube, .popup-vimeo, .popup-gmaps').magnificPopup({
      disableOn: 700,
      type: 'iframe',
      mainClass: 'mfp-fade',
      removalDelay: 160,
      preloader: false,

      fixedContentPos: false,
    });

    function updateDatePicker(element, index, value, clearSelection = false) {
      const location = $(element).data('location');
      $('.af-field-location input').val(location);
      let currentDate = element.attr('data-selected-date');
      console.log('currentDate', currentDate);
      const dateTimeArray = currentDate.split(' ');
      const currentDateArray = dateTimeArray[0].split('-');
      let currentTime = dateTimeArray[1];
      if (index > currentDateArray.length - 1) {
        currentTime = value;
      } else {
        currentDateArray[index] = value;
      }
      currentDate = currentDateArray.join('-');
      const currentDateTime = currentDate + ' ' + currentTime;
      element.attr('data-selected-date', currentDateTime);
      if (clearSelection) {
        $('.custom-date-time-picker .acf-date-time-picker input').val('');
        element.attr('data-selected-date', currentDateArray[0] + '-' + currentDateArray[1] + '-xx ' + currentTime);
      } else if (!currentDate.includes('x') && !currentTime.includes('t')) {
        $('.custom-date-time-picker .acf-date-time-picker input').val(currentDateTime);
      }
    }

    // Date picker
    $('.date-time-picker .date').click(function(e) {
      e.preventDefault();
      
      const datePicker = $(this).closest('.date-time-picker');
      const day = $(this).data('day');
      updateDatePicker(datePicker, 2, day);
    });

    $('.date-time-picker .month').click(function(e) {
      e.preventDefault();
      
      const datePicker = $(this).closest('.date-time-picker');
      const monthYear = $(this).data('month-year');
      const monthYearArray = monthYear.split('-');
      updateDatePicker(datePicker, 1, monthYearArray[0]);
      updateDatePicker(datePicker, 0, monthYearArray[1], true);
    });

    $('.date-time-picker .time').click(function(e) {
      e.preventDefault();
      
      const datePicker = $(this).closest('.date-time-picker');
      const time = $(this).data('time');
      updateDatePicker(datePicker, 3, time);
    });

    // Smooth scroll
    $('a.smooth-scroll, .smooth-scroll a').click(function (event) {
      event.preventDefault();
      const offset = $(this.hash).offset().top;
      console.log('offset', offset);

      if (offset !== null) {
        event.preventDefault();
        // var hash = this.hash;
        $('html, body').animate({
          scrollTop: offset,
        }, 600, function () {
          // if (hash) {
          //   window.location.hash = hash;
          // }
        });
      }
    });

    // Stop sidebar at footer
    // NEEDS REWORKING, SIDEBAR STUTTERS
    $(window).on('load scroll resize', function () {
      const sidebar = $('.sidebar-fixed-height');

      const viewTop = $(window).scrollTop();
      const footerTop = $('footer').offset().top;
      const sidebarHeight = $('.sidebar').outerHeight();
      const distance = footerTop - (viewTop + sidebarHeight);

      if (distance < 0) {
        sidebar.css('margin-top', distance)
        sidebar.css('margin-bottom', distance * -1)
      } else {
        sidebar.css('margin-top', 0)
        sidebar.css('margin-bottom', 0)
      }
    });

    $('.animated-counter').each(function () {
      $(this).prop('Counter', 0).animate({
        Counter: $(this).text(),
      },
      {
        duration: 2000,
        easing: 'swing',
        step: function (now) {
          $(this).text(Math.ceil(now));
        },
      });
    });

    // Case study slider
     $('.case-study-slider-main').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      fade: true,
      // asNavFor: '.case-study-slider-nav',
      infinite: true,
    });

    // $('.case-study-slider-nav').slick({
    //   slidesToShow: 2,
    //   slidesToScroll: 1,
    //   // asNavFor: '.case-study-slider-main',
    //   // dots: true,
    //   focusOnSelect: true,
    //   arrows: true,
    //   infinite: true,
    //   nextArrow: '<div class="slick-next">></div>',
    //   fade: true,
    // });

    $('.case-study-slider-nav').slick({
      infinite: true,
      speed: 500,
      fade: true,
      cssEase: 'linear',
      // asNavFor: '.case-study-slider-main',
      nextArrow: '<div class="slick-next">></div>',
      initialSlide: 1,
    });

    // On before slide change
    $('.case-study-slider-nav').on('beforeChange', function(event, slick, currentSlide, nextSlide){
      const index = nextSlide - 1;
      $('.case-study-slider-main').slick('slickGoTo', index);
    });

    // Gallery slider
    $('.gallery-slider').slick({
      infinite: true,
      speed: 500,
      fade: true,
      cssEase: 'linear',
      arrows: false,
      autoplay: true,
      autoplaySpeed: 4000,
    });

    $('.newsletter-slider').slick({
      infinite: true,
      slidesToShow: 4,
      slidesToScroll: 1,
      arrows: true,
      prevArrow: '<div class="slick-prev"><</div>',
      nextArrow: '<div class="slick-next">></div>',
      responsive: [
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
          },
        },
      ],
    });

    // Video Gallery
    $('.video-gallery .video-gallery-slider').slick({
      infinite: true,
      speed: 500,
      slidesToShow: 2,
      slidesToScroll: 1,
      arrows: true,
      prevArrow: '<div class="slick-prev"><</div>',
      nextArrow: '<div class="slick-next">></div>',
      responsive: [
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
      ],
    });

    // Nav toggler
    $('.navbar-toggler').click(function() {
      const toggler = $('.navbar-toggler');
      if ($(this).hasClass('collapsed')) {
        toggler.removeClass('collapsed');
        $('.header-menu').addClass('active');
        $('header.banner').addClass('active');
        $('body').addClass('static');
      } else {
        toggler.addClass('collapsed');
        $('.header-menu').removeClass('active');
        $('header.banner').removeClass('active');
        $('body').removeClass('static');
      }
    });

    // Date picker
    $('.dates .date').click(function(e) {
      e.preventDefault();

      const date = $(this);
      const dates = date.closest('.dates');
      
      dates.find('.date').removeClass('active');
      date.addClass('active');
    });

    $('.months .month').click(function(e) {
      e.preventDefault();

      $('.date').removeClass('active');

      // const month = $(this);
      // const months = month.closest('.months');
      
      // months.find('.month').removeClass('active');
      // month.addClass('active');
    });

    $('.times .time').click(function(e) {
      e.preventDefault();

      const time = $(this);
      const times = time.closest('.times');
      
      times.find('.time').removeClass('active');
      time.addClass('active');
    });

    $('.acf-date-picker input').focus(function() {
      $(this).closest('.acf-date-picker').addClass('active');
    });

    // Stat circles
    if($('.stats').length > 0){

      let circle = []

      $('.stats').each(function(index){
        let blockId = $(this).data('block')

        let element = `[data-block=${blockId}] .circle`

        let percentage = $(element).data('percentage')
        
        circle[index] = new ProgressBar.Circle(element, {
          strokeWidth: 4,
          easing: 'easeInOut',
          duration: 1400,
          color: '#85529c',
          trailColor: '#C4C3CE',
          trailWidth: 2,
            text: {
              value: '0',
          },
          step: function(state, bar) {
            bar.setText((bar.value() * 100).toFixed(0) + '%');
          },
        })
        
        circle[index].animate(percentage)
      })
    }

    // Nav Tabs
    function updateNavTab(navLink, enableUnderline = true) {
      const navItem = navLink.closest('.nav-item');
      const navTabs = navLink.closest('.nav.tabs');
      const navUnderline = navTabs.find('.nav-underline');

      const navItemOffsetLeft = navItem.offset().left;
      const navTabsOffsetLeft = navTabs.offset().left;
      const navItemWidth = navItem.width();

      const leftOffset = navItemOffsetLeft - navTabsOffsetLeft + navItemWidth * 0.5;
      navUnderline.css('left', leftOffset + 'px');

      navUnderline.addClass('loaded');

      if (enableUnderline) {
        navUnderline.addClass('enabled');
      }
    }

    $(window).on('load', function() {
      $('.nav.tabs .nav-item .nav-link').each(function() {
        const isActive = $(this).hasClass('active');
        if (isActive) {
          updateNavTab($(this), false);
        }
      });
    });

    $('.nav.tabs .nav-item .nav-link').click(function() {
      updateNavTab($(this))
    });

    // Test
    $('.alum-collapse-trigger').click(function() {
      $('.collapse').collapse('hide');

      const container = $(this).closest('.container');

      const offset = container.offset().top + container.outerHeight();

      if (offset !== null) {
        $('html, body').animate({
          scrollTop: offset,
        }, 600, function () {
        });
      }
    });

    // Location search form
    $('.location-seach-form .location-search-input button').click(function(e) {
      e.preventDefault();
      const form = $(this).closest('.location-seach-form');
      form.submit();
      console.log('cclick');
    });

    // Popup
    $('.popup-zoom').magnificPopup({
      type: 'inline',

      fixedContentPos: false,
      fixedBgPos: true,

      overflowY: 'auto',

      closeBtnInside: true,
      preloader: false,
      
      midClick: true,
      removalDelay: 300,
      mainClass: 'my-mfp-zoom-in',
    });
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js